import { Component, EventEmitter, Input, Output } from '@angular/core';
import { cloneDeep } from '@apollo/client/utilities';
import { NewsItem, ReactionEnum } from '@cpd-app/generated';

@Component({
  selector: 'cpd-news-card',
  templateUrl: './news-card.component.html',
  styleUrls: ['./news-card.component.scss'],
})
export class NewsCardComponent {
  @Input() public news: NewsItem;
  @Input() public isFull = false;

  @Output() public react = new EventEmitter<ReactionEnum>();
  @Output() public view = new EventEmitter<NewsItem>();

  public readonly bugFixType = 'Bug Fix';
  public readonly reactionEnum = ReactionEnum;
  public readonly reactionEnumNumber = {
    Dislike: -1,
    Like: 1,
  };

  public reactOnNews(value: ReactionEnum): void {
    this.react.emit(value);
  }

  public viewMore(): void {
    this.view.emit(cloneDeep(this.news));
  }
}
